import React, {forwardRef} from "react";

export default function JsxRenderer(props){
    let jsx = props.jsx(props);
    return <div>
        {jsx}
    </div>
};